/**
 * Not all hooks in react-use currently support React Native, since some browser specific ones access the `document`
 * global.  Therefore, importing the whole lib causes an error on native devices.  As such, this middleware simply
 * imports the hooks that we need directly from source, and exports them again for use.
 *
 * @see https://github.com/streamich/react-use/issues/829
 */

export { default as useMountedState } from 'react-use/lib/useMountedState';
